import React from 'react';
import { Section } from './Section';
import { CheckCircle2 } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    title: 'Sentirte más despierto y ágil mentalmente',
    desc: 'recordás mejor, te concentrás más fácil, reaccionás más rápido.'
  }, {
    title: 'Armar una rutina propia para cuidar tu cabeza',
    desc: 'con 15 o 20 minutos por día alcanza.'
  }, {
    title: 'Hacer ejercicios que te tratan como adulto',
    desc: 'nada para chicos, nada condescendiente, todo serio y bien pensado.'
  }, {
    title: 'Preocuparte menos por los pequeños olvidos',
    desc: 'y sentirte más seguro de vos mismo.'
  }, {
    title: 'Mantenerte independiente y activo',
    desc: 'seguir haciendo tu vida sin depender tanto de los demás.'
  }, {
    title: 'Disfrutar mientras lo hacés',
    desc: 'son actividades entretenidas, no una obligación pesada.'
  }];
  return <Section className="bg-white" data-id="element-16">
      <div className="text-center mb-12" data-id="element-17">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-18">
          Con este kit vas a poder...
        </h2>
        <p className="text-xl text-gray-600" data-id="element-19">
          Cambios reales que vas a notar en poco tiempo:
        </p>
      </div>

      <div className="space-y-4 max-w-3xl mx-auto" data-id="element-20">
        {benefits.map((benefit, idx) => <div key={idx} className="flex gap-4 items-start p-4 hover:bg-sage-50 rounded-xl transition-colors" data-id="element-21">
            <CheckCircle2 className="text-sage-600 shrink-0 mt-1" size={28} data-id="element-22" />
            <div data-id="element-23">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-24">
                {benefit.title}
              </h3>
              <p className="text-gray-600 mt-1" data-id="element-25">— {benefit.desc}</p>
            </div>
          </div>)}
      </div>
    </Section>;
}